import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
// @mui
import { Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CommentForm } from '../sections/comment_action';
// sections

// ------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    width: '60vw',
    minWidth: 320,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(4, 0),
}));

// ---------------------------------------------------------------------

export default function CommentAction() {
    const { id } = useParams();
    const isEditMode = !!id;

    return (
        <>
            <Helmet>
                <title> {!isEditMode ? 'Create' : 'Edit'} Comment | Trooper</title>
            </Helmet>

            <Container>
                <Typography variant="h4" gutterBottom>
                    {!isEditMode ? 'Create' : 'Edit'} Comment
                </Typography>

                <StyledContent>
                    <CommentForm edit={isEditMode} />
                </StyledContent>
            </Container>
        </>
    );
}
